const INVALID_PROVIDER_CREDENTIAL_PATTERNS = [
	/\binvalid_api_key\b/i,
	/incorrect api key provided/i,
	/api key not valid/i,
	/api key not found/i,
	/please pass a valid api key/i,
];

const PROVIDER_ERROR_PATTERN = /error from provider\s+([a-z0-9._-]+)/i;

export function hasInvalidProviderCredentialError(errorText?: string): boolean {
	if (!errorText) {
		return false;
	}

	return INVALID_PROVIDER_CREDENTIAL_PATTERNS.some((pattern) =>
		pattern.test(errorText),
	);
}

export function extractProviderIdFromErrorText(
	errorText?: string,
): string | null {
	if (!errorText) {
		return null;
	}

	const match = errorText.match(PROVIDER_ERROR_PATTERN);
	return match?.[1]?.toLowerCase() ?? null;
}

export function hasProviderAuthorizationError(errorText?: string): boolean {
	if (!errorText) {
		return false;
	}

	return (
		hasInvalidProviderCredentialError(errorText) ||
		/error from provider\s+[a-z0-9._-]+:\s*(401|403)\b/i.test(errorText) ||
		/\b(401|403)\s+unauthorized\b/i.test(errorText) ||
		/\bforbidden\b/i.test(errorText)
	);
}
